var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconMessaging = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M2 1C.9 1 0 1.9 0 3v12l3-3h3v3c0 1.1.9 2 2 2h9l3 3V8c0-1.1-.9-2-2-2h-4V3c0-1.1-.9-2-2-2zm0 2h10v7H2zm12 5h4v7H8v-3h4c1.1 0 2-.9 2-2z"
})));
export default SvgIconMessaging;